var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('svg',{ref:"svg",staticStyle:{"max-width":"100%","height":"auto"},attrs:{"width":_vm.width,"height":_vm.height,"viewBox":'0 0 ' + _vm.width + ' ' + _vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }